// Utils
import { formValidators } from "@benchmark/ui/utils";

// Types
import type { ProviderOrganizationFormData } from "@benchmark/core/types";

/**
 * Returns validation errors for organization section form data.
 * @agentic @benchmark/core
 */
export const getOrganizationSectionErrors = (
  organization: ProviderOrganizationFormData | undefined,
  fieldPath: string,
): Record<string, string> => {
  if (!organization || !organization.isNew) {
    return {};
  }

  const errorEntries: Array<[string, string]> = [];

  const nameError = formValidators.required("Organization name")(
    organization.name,
  );
  const typeError = formValidators.required("Organization type")(
    organization.type,
  );

  if (nameError) {
    errorEntries.push([`${fieldPath}.name`, nameError]);
  }
  if (typeError) {
    errorEntries.push([`${fieldPath}.type`, typeError]);
  }

  return Object.fromEntries(errorEntries);
};
